// Contact details, used by the Services and Contact sections.
export const EMAIL = 'gibendigoodness@gmail.com';

const WHATSAPP_GREETING = 'Hi Goodness, I found your portfolio and would like to talk about a project.';
export const WHATSAPP_URL = `https://wa.me/254718175283?text=${encodeURIComponent(WHATSAPP_GREETING)}`;
